import { render, staticRenderFns } from "./PersonalDocumentacion.vue?vue&type=template&id=b7540598"
import script from "./PersonalDocumentacion.vue?vue&type=script&lang=js"
export * from "./PersonalDocumentacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports